import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
  } from "react";
  import Select from "react-select";
  
  export default forwardRef((props, ref) => {
    const [filterText, setFilterText] = useState([]);
    // expose AG Grid Filter Lifecycle callbacks
    useImperativeHandle(ref, () => {
      return {
        doesFilterPass(params) {
          const { api, colDef, column, columnApi, context } = props;
          const { node } = params;
          let passed = true;
          const value = props.valueGetter({
            api,
            colDef,
            column,
            columnApi,
            context,
            data: node.data,
            getValue: (field) => node.data[field],
            node,
          });
  
          if (
            !(filterText || []).length ||
            (filterText || []).indexOf("all") != -1
          ) {
            return true;
          }
  
          let count = 0;
          filterText.forEach(item => {
            if (value.toLowerCase().indexOf(item) != -1) {
              count = count + 1;
            }
          });
  
          if (count === 0) {
            passed = false;
          }
          return passed;
        },
  
        isFilterActive() {
          return filterText != null && filterText !== "";
        },
  
        getModel() {
          if (!this.isFilterActive()) {
            return null;
          }
  
          return { value: filterText };
        },
  
        setModel(model) {
          setFilterText(model == null ? null : model.value);
        },
      };
    });
  
    const onChange = (e) => {
      setFilterText(Array.isArray(e) ? e.map((x) => x.value) : []);
    };
  
    useEffect(() => {
      props.filterChangedCallback();
    }, [filterText]);
  
    const chatStateOption = [
      { value: "flow", label: "Flow" },
      { value: "queue", label: "Queue" },
      { value: "assigned", label: "Assigned" },
      { value: "closed", label: "Closed" },
    ];
    return (
      <div style={{ width: "200px", height: "178px" }}>
        <Select
          placeholder="Select Option"
          value={chatStateOption.filter((obj) =>
            filterText.includes(obj.value)
          )} // set selected values
          options={chatStateOption} // set list of the data
          onChange={onChange} // assign onChange function
          isMulti
          isClearable
          menuIsOpen
        />
      </div>
    );
  });
  


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/DynamicAgTableCustomFilterChatState.js